import {
  Sections,
  ShippingCaseFields,
  ModeOfTransport,
  ShippingCaseResponse,
} from "../types";

export const mapOfferDetailsData = (data: ShippingCaseResponse) => {
  return {
    [Sections.SERVICES]: {
      [ShippingCaseFields.CUSTOMER_DETAILS]: data.offer.customer.name || "",
      [ShippingCaseFields.NUMBER_OF_SHIPPING]: data.id,
      [ShippingCaseFields.FLOW_OF_GOODS]:
        data.offer.flow_of_goods?.toLowerCase(),
      [ShippingCaseFields.MODE_OF_TRANSPORT]: data.offer.mode_of_transport
        ? ModeOfTransport[
            data.offer.mode_of_transport as keyof typeof ModeOfTransport
          ]
        : "",
      [ShippingCaseFields.TYPE_OF_CARGO]:
        data.offer.type_of_shipment === "BULK"
          ? "Bulk"
          : `Container ${data.offer.container_shipment_type}`,
      [ShippingCaseFields.ASSIGNED_OFFICE]: data.offer.assigned_office?.name,
      [ShippingCaseFields.REFFERENCE_OFFER]: data.offer.id,
      [ShippingCaseFields.SEAWAY_USER]: `${data.offer.operator.first_name} ${data.offer.operator.last_name}`,
      [ShippingCaseFields.INCOTERMS]:
        data.offer.incoterm === "CFR_CIF" ? "CFR/CIF" : data.offer.incoterm,
      [ShippingCaseFields.DISCHARGE_PORT]:
        data.offer.discharge_port?.title || "",
      [ShippingCaseFields.TERMINAL]: data.terminal?.name || "",
    },
  };
};
